import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { PureComponent } from 'react';

import styles from './messageWidgetInput.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
  /** Input label */
  label: string;
  /** Input placeholder */
  placeholder: string;
};

export class MessageWidgetInput extends PureComponent<PropsT> {
  render() {
    const { className, label, placeholder, ...otherProps } = this.props;

    const rootClass = classnames(
      {
        [styles.root]: true,
      },
      className,
    );

    return (
      <div {...otherProps} className={rootClass}>
        <span className={styles.label}>{label}</span>
        <div className={styles.input}>
          <span className={styles.placeholder}>{placeholder}</span>
          <DixaIcon className={styles.icon} icon="arrow-square-right" />
        </div>
      </div>
    );
  }
}
